"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var dyna_interfaces_1 = require("dyna-interfaces");
var DynaNodeService_1 = require("../DynaNodeService/DynaNodeService");
var interfacesMasterWorker_1 = require("../DynaNodeMasterService/interfacesMasterWorker");
var consoleStringify_1 = require("../utils/consoleStringify");
var isCommand_1 = require("../utils/isCommand");
var global_1 = require("../utils/global");
var console_INVESTIGATE2665 = !!global_1.g.env && !!global_1.g.env.console_INVESTIGATE2665;
var DynaNodeMasterService = /** @class */ (function () {
    function DynaNodeMasterService(_config) {
        this._config = _config;
        this._workersArray = [];
        this._workersDic = {};
        this._createService();
    }
    DynaNodeMasterService.prototype._createService = function () {
        var _this = this;
        this._service = new DynaNodeService_1.DynaNodeService({
            compressMessages: this._config.compressMessages,
            disk: this._config.disk,
            parallelRequests: this._config.parallelRequests,
            serviceRegistration: this._config.serviceRegistration,
            retryConnectionConfig: this._config.retryConnectionConfig,
            defaultsServiceMessagePriorityValue: this._config.defaultsServiceMessagePriorityValue,
            defaultExecutionTimeout: this._config.defaultExecutionTimeout,
            headers: this._config.headers,
            publicCommands: new Array().concat(interfacesMasterWorker_1.COMMAND_DynaNodeMasterServiceMessageRegisterWorker, interfacesMasterWorker_1.COMMAND_DynaNodeMasterServiceMessageHeartbeat, this._config.publicCommands
                ? this._config.publicCommands
                : new Array()
                    .concat(this._config.onCommand && Object.keys(this._config.onCommand) || [], this._config.onWorkerCommands && this._config.onWorkerCommands || [])),
            onCommand: __assign(__assign({}, (this._config.onCommand || {})), this.internalCommands),
            onBeforeAnyCommand: this._config.onBeforeAnyCommand,
            onUnknownCommand: this._config.onUnknownCommand,
            onClientConnectionLost: function () { return undefined; },
            onServiceRegistrationFail: function (error) {
                return console.error("DynaNodeMasterService [" + _this._service.friendlyName + "]: cannot register to dyna node server", consoleStringify_1.consoleStringify({
                    serviceDynaNodeAddress: _this._config.serviceRegistration.serverDynaNodeAddress,
                    serviceConnectionId: _this._config.serviceRegistration.serviceConnectionId,
                    error: error,
                }));
            },
            onMessageQueueError: function (error) {
                return console.error("DynaNodeMasterService [" + _this._service.friendlyName + "]: message queue error (h/w, disk?)", consoleStringify_1.consoleStringify({
                    serviceDynaNodeAddress: _this._config.serviceRegistration.serverDynaNodeAddress,
                    serviceConnectionId: _this._config.serviceRegistration.serviceConnectionId,
                    error: error,
                }));
            },
        });
    };
    DynaNodeMasterService.prototype.start = function () {
        return this._service.start();
    };
    DynaNodeMasterService.prototype.stop = function (waitForPendingMessages) {
        if (waitForPendingMessages === void 0) { waitForPendingMessages = true; }
        return this._service.stop(waitForPendingMessages);
    };
    Object.defineProperty(DynaNodeMasterService.prototype, "active", {
        get: function () {
            return this._service.active;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeMasterService.prototype, "ready", {
        get: function () {
            return this._service.ready;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeMasterService.prototype, "friendlyName", {
        get: function () {
            return this._service.friendlyName;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeMasterService.prototype, "serviceAddress", {
        get: function () {
            return this._service.serviceAddress;
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeMasterService.prototype.sendToMe = function (args) {
        this._service.sendToMe(args);
    };
    DynaNodeMasterService.prototype.sendToMeMessage = function (message) {
        this._service.sendToMeMessage(message);
    };
    DynaNodeMasterService.prototype.send = function (config) {
        return this._service.send(config);
    };
    DynaNodeMasterService.prototype.sendReceive = function (config) {
        return this._service.sendReceive(config);
    };
    DynaNodeMasterService.prototype.reply = function (sourceMessage, config) {
        return this._service.reply(sourceMessage, config);
    };
    DynaNodeMasterService.prototype.fetch = function (config) {
        return this._service.fetch(config);
    };
    /**
     * Send a message to worker.
     * It finds a worker and retries if this worker died with another one.
     * @param config
     * Returns: The response of the worker or null for success sent.
     */
    DynaNodeMasterService.prototype.sendWorker = function (config) {
        var _this = this;
        var workerDynaNodeAddress;
        return Promise.resolve()
            .then(function () { return workerDynaNodeAddress = _this.getAvailableWorkerDynaNodeAddress(config.command); })
            .then(function () {
            if (!workerDynaNodeAddress)
                return Promise.reject({
                    code: 404.202,
                    section: "DynaNodeMasterService/sendWorker",
                    message: "No worker is available",
                    data: {
                        service: _this._service.friendlyName,
                        command: config.command,
                    },
                });
            return Promise.resolve();
        })
            .then(function () {
            return _this._service.send(__assign(__assign({}, config), { to: workerDynaNodeAddress }));
        })
            .catch(function (error) {
            if (error.code === 404.101) {
                // The worker is not connected anymore,
                if (console_INVESTIGATE2665)
                    console.warn('INVESTIGATE2665 - 90001 Remove worker - 404.101 worker cannot be reached anymore (on send)', workerDynaNodeAddress);
                _this.removeWorker(workerDynaNodeAddress); // remove this worker, is dead
                return _this.sendWorker(config); // retry (with recursive call)
            }
            else {
                // for any other error, return the error
                return Promise.reject(error);
            }
        });
    };
    DynaNodeMasterService.prototype.sendWorkerPushClientMessage = function (message, onRetry) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, sendToWorkerTimeout, workerDynaNodeAddress, dynaNodeAckTimeout, response, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this._config.sendToWorkerTimeout, sendToWorkerTimeout = _a === void 0 ? 10300 : _a;
                        workerDynaNodeAddress = this.getAvailableWorkerDynaNodeAddress(message.command);
                        if (!workerDynaNodeAddress) {
                            message._addTrace('DynaNode/MasterService/PUSH_INCOMING_TO_WORKER_ERROR', "DynaNode: DynaNodeMaster, No worker is available, 404.202", this._traceData);
                            throw {
                                code: 404.202,
                                section: "DynaNodeMasterService/sendWorkerPushClientMessage",
                                message: "No worker is available",
                                data: {
                                    service: this._service.friendlyName,
                                    command: message.command,
                                },
                            };
                        }
                        dynaNodeAckTimeout = message.headers.dynaNodeAckTimeout || (sendToWorkerTimeout - 500);
                        if (dynaNodeAckTimeout >= sendToWorkerTimeout - 500)
                            dynaNodeAckTimeout = sendToWorkerTimeout - 500;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        message._addTrace('DynaNode/MasterService/MASTER_SENDING_TO_WORKER', "DynaNode: DynaNodeMaster, Pushing the message to worker", this._traceData);
                        return [4 /*yield*/, this._service.sendReceive(__assign(__assign({}, message), { to: workerDynaNodeAddress, command: interfacesMasterWorker_1.COMMAND_DynaNodeWorkerServiceWorkerWrappedMessage, headers: __assign(__assign({}, message.headers), { // Todo: try to remove this, the tests should be agail correct
                                    dynaNodeAckTimeout: dynaNodeAckTimeout }), args: {
                                    serviceMessagePriorityValue: 0,
                                }, data: {
                                    master: {
                                        originalData: {
                                            id: message.id,
                                            from: message.from,
                                            to: message.to,
                                            headers: message.headers,
                                            args: message.args,
                                            command: message.command,
                                            data: message.data,
                                            dynaNodeInfo: message.dynaNodeInfo,
                                            traces: message.traces.concat(),
                                        },
                                    },
                                }, addTraces: {
                                    copyFromMessage: message,
                                    addTrace: {
                                        section: 'DynaNode/MasterService/MASTER_SENDING_TO_WORKER',
                                        desc: "DynaNode: DynaNodeMaster, Pushing the message to worker",
                                    },
                                } }))];
                    case 2:
                        response = _b.sent();
                        if (isCommand_1.isCommandError(response.command))
                            throw response.data;
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        switch (error_1.code) {
                            case 404.101: // The worker is not connected anymore
                                if (console_INVESTIGATE2665)
                                    console.warn('INVESTIGATE2665 - 90002 Remove worker - 404.101 worker cannot be reached anymore (on push)', consoleStringify_1.consoleStringify(workerDynaNodeAddress));
                                this.removeWorker(workerDynaNodeAddress); // remove this worker, is dead
                                onRetry();
                                message._addTrace('DynaNode/MasterService/PUSH_INCOMING_TO_WORKER__RETRY_404_101', "DynaNode: DynaNodeMaster, Pushing the message to worker due to a problem reaching an active worker", this._traceData);
                                return [2 /*return*/, this.sendWorkerPushClientMessage(message, onRetry)]; // retry (with recursive call)
                            case 133.144: // Acknowledge: The message couldn't be delivered with the timeout to the worker
                                if (console_INVESTIGATE2665)
                                    console.warn("INVESTIGATE2665 - 90003 Remove worker - 144.144 worker cannot be reached anymore (on push & failed ack) address: " + workerDynaNodeAddress + " dynaNodeAckTimeout: " + dynaNodeAckTimeout);
                                message._addTrace('DynaNode/MasterService/PUSH_INCOMING_TO_WORKER__RETRY_133_144', "DynaNode: DynaNodeMaster, Pushing the message to worker due unresponsive (in timeout) worker", this._traceData);
                                this.removeWorker(workerDynaNodeAddress); // remove this worker, is bad
                                onRetry();
                                return [2 /*return*/, this.sendWorkerPushClientMessage(message, onRetry)]; // retry (with recursive call)
                            default:
                                throw error_1;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * SendReceive a message to worker.
     * ATTENTION: The worker should respond something! Otherwise the service will stuck due to parallel request threshold.
     * Usually the workers don't respond to master, use the sendWorker instead.
     * It find a worker and retries if this worker died with another one.
     * @param config
     * Returns: The response of the worker or null for success sent.
     */
    DynaNodeMasterService.prototype.sendReceiveWorker = function (config) {
        var _this = this;
        var workerDynaNodeAddress;
        return Promise.resolve()
            .then(function () { return workerDynaNodeAddress = _this.getAvailableWorkerDynaNodeAddress(config.command); })
            .then(function () {
            if (!workerDynaNodeAddress)
                return Promise.reject({
                    code: 404.202,
                    section: "DynaNodeMasterService/sendReceiveWorker",
                    message: "No worker is available for command [" + config.command + "]",
                });
            return Promise.resolve();
        })
            .then(function () { return _this._service.sendReceive(__assign(__assign({ to: workerDynaNodeAddress }, config), { headers: __assign(__assign({}, config.headers), { dynaNodeAckTimeout: 3211 }) })); })
            .catch(function (error) {
            switch (error.code) {
                case 404.101:
                    // The worker is not connected anymore,
                    if (console_INVESTIGATE2665)
                        console.warn('INVESTIGATE2665 - 90004 Remove worker - failed sendReceive', workerDynaNodeAddress);
                    _this.removeWorker(workerDynaNodeAddress); // remove this worker, is dead
                    return _this.sendReceiveWorker(config); // retry (with recursive call)
                case 133.144:
                    // The worker delayed to response, ACK error (dynaNodeAckTimeout), it is considered as dead,
                    if (console_INVESTIGATE2665)
                        console.warn('INVESTIGATE2665 - 90007 Remove worker - ack error', workerDynaNodeAddress);
                    _this.removeWorker(workerDynaNodeAddress); // remove this worker, is dead
                    return _this.sendReceiveWorker(config); // retry (with recursive call)
                default:
                    // for any other error, return it as response
                    return Promise.reject(error);
            }
        });
    };
    DynaNodeMasterService.prototype.getAvailabilityIndex = function () {
        return this._service.getAvailabilityIndex();
    };
    Object.defineProperty(DynaNodeMasterService.prototype, "stats", {
        get: function () {
            return __assign({ availabilityIndex: this.getAvailabilityIndex(), workers: this._workersArray }, this._service.stats);
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeMasterService.prototype.getAvailableWorkerDynaNodeAddress = function (command) {
        var _this = this;
        if (this._workersArray.length === 0)
            return "";
        var sortedWorkers = this._workersArray
            .filter(function (worker) { return worker.publicCommands.includes(command); })
            .sort(function (workerA, workerB) { return _this.getWorkerAvailabilityIndex(workerA) - _this.getWorkerAvailabilityIndex(workerB); });
        var mostAvailableWorkers = sortedWorkers
            .reduce(function (acc, worker, index) {
            if (index === 0)
                return acc;
            if (worker.availabilityIndex === acc[0].availabilityIndex)
                acc.push(worker);
            return acc;
        }, [sortedWorkers[0]]);
        var mostUnsedWorkders = mostAvailableWorkers
            .sort(function (workerA, workerB) { return workerA.lastTimeChosen - workerB.lastTimeChosen; });
        var worker = mostUnsedWorkders[0];
        if (worker)
            worker.lastTimeChosen = Date.now();
        return worker && worker.dynaNodeAddress || "";
    };
    DynaNodeMasterService.prototype.getWorkerAvailabilityIndex = function (worker) {
        return (worker.availabilityIndex
            + this.getPingTimeout(worker));
    };
    DynaNodeMasterService.prototype.getPingTimeout = function (worker) {
        var pingTimeoutFactor = 0.1;
        if (worker.pingTimeout.length === 0)
            return 0;
        return ((worker.pingTimeout.reduce(function (acc, i) { return acc + i; }, 0) / worker.pingTimeout.length) * pingTimeoutFactor);
    };
    Object.defineProperty(DynaNodeMasterService.prototype, "internalCommands", {
        get: function () {
            var _a;
            var _this = this;
            var _b = this._config.sendToWorkerTimeout, sendToWorkerTimeout = _b === void 0 ? 10300 : _b;
            return __assign((_a = {}, _a[interfacesMasterWorker_1.COMMAND_DynaNodeMasterServiceMessageRegisterWorker] = {
                executionTimeout: 2000,
                execute: function (_a) {
                    var message = _a.message, reply = _a.reply, next = _a.next;
                    var affiliateAccount = message.data.affiliateAccount;
                    if (_this._config.validateAffiliateAccount(affiliateAccount.username, affiliateAccount.password)) {
                        _this.addWorker({
                            affiliateUsername: affiliateAccount.username,
                            dynaNodeAddress: message.from,
                            lastHeartbeat: Date.now(),
                            availabilityIndex: message.data.availabilityIndex,
                            pingTimeout: [],
                            publicCommands: message.data.publicCommands,
                            lastTimeChosen: Date.now(),
                        });
                        reply({
                            command: "deal",
                            data: {
                                heartbeatInterval: _this._config.workerHeartbeatInterval,
                            },
                        });
                        next();
                    }
                    else {
                        reply({
                            command: "error/dyna-node/300/120",
                            data: {
                                code: 1809222012,
                                message: "Wrong credentials",
                                errorType: dyna_interfaces_1.EErrorType.USER,
                            },
                        });
                        next();
                    }
                },
            }, _a[interfacesMasterWorker_1.COMMAND_DynaNodeMasterServiceMessageHeartbeat] = {
                executionTimeout: 2000,
                execute: function (_a) {
                    var message = _a.message, reply = _a.reply, next = _a.next;
                    var worker = _this._workersDic[message.from];
                    if (worker) {
                        worker.lastHeartbeat = Date.now();
                        worker.availabilityIndex = message.data.availabilityIndex;
                        _this.updateWorkerPingTimeout(worker);
                    }
                    else {
                        reply({ command: interfacesMasterWorker_1.COMMAND_DynaNodeWorkerServiceYouAreDead }).catch(function () { return undefined; });
                    }
                    next();
                },
            }, _a), (this._config.onWorkerCommands || [])
                .reduce(function (acc, workerCommand) {
                acc[workerCommand] = {
                    executionTimeout: sendToWorkerTimeout,
                    execute: function (_a) {
                        var message = _a.message, reply = _a.reply, resetExecutionTimer = _a.resetExecutionTimer, next = _a.next;
                        _this.sendWorkerPushClientMessage(message, resetExecutionTimer)
                            .catch(function (error) {
                            if (error.code === 404.202) { // No worker is available
                                console.error("DynaNodeMasterService [" + _this._service.friendlyName + "]: Error 404.202 No worker is available for command [" + message.command + "], sendWorkerPushClientMessage error: " + error.message, consoleStringify_1.consoleStringify({ error: error }));
                                reply({
                                    command: "error/dyna-node/404/205",
                                    args: null,
                                    data: error,
                                });
                            }
                            else {
                                // for all other error codes
                                var applyError = {
                                    errorType: dyna_interfaces_1.EErrorType.APP,
                                    code: 500.103,
                                    section: 'DynaNodeMaster/onWorkerError/process',
                                    message: "Master: " + _this._service.friendlyName + ", general send error for worker command " + message.command + ", worker found but there was another error.",
                                    data: {
                                        onWorkerCommand: message.command,
                                        workerCommand: workerCommand,
                                        commandRepliedToClient: "error/dyna-node/404/205",
                                    },
                                    error: error,
                                };
                                console.error("DynaNodeMasterService [" + _this._service.friendlyName + "]: On Worker command error 202001280737, sendWorkerPushClientMessage error: " + applyError.message, consoleStringify_1.consoleStringify(applyError));
                                reply({
                                    command: "error/dyna-node/500/103",
                                    args: null,
                                    data: applyError,
                                });
                            }
                        })
                            .then(next);
                    },
                };
                return acc;
            }, {}));
        },
        enumerable: true,
        configurable: true
    });
    DynaNodeMasterService.prototype.updateWorkerPingTimeout = function (worker) {
        var _this = this;
        var start = Date.now();
        this._service.sendReceive({
            to: worker.dynaNodeAddress,
            command: interfacesMasterWorker_1.COMMAND_DynaNodeWorkerServicePing,
            args: {
                serviceMessagePriorityValue: 0,
            },
            replyTimeoutInMs: 3000,
        })
            .then(function (message) {
            if (message.command === 'pong') {
                worker.pingTimeout.push(Date.now() - start);
                worker.pingTimeout = worker.pingTimeout.slice(-10); // keep the last 10 only
            }
            else {
                console.error("DynaNodeMasterService [" + _this._service.friendlyName + "]: Worker didn't response with pong", consoleStringify_1.consoleStringify({ message: message.viewSecure }));
            }
        })
            .catch(function (error) {
            if (error.code === 404.101) {
                if (console_INVESTIGATE2665)
                    console.warn('INVESTIGATE2665 - 90005 Remove worker - failed updateWorkerPingTimeout', worker.dynaNodeAddress);
                _this.removeWorker(worker.dynaNodeAddress); // remove this worker, is dead
            }
            else {
                if (console_INVESTIGATE2665)
                    console.error("DynaNodeMasterService [" + _this._service.friendlyName + "]: updatePingTimeout send or reply timeout error", consoleStringify_1.consoleStringify(error));
            }
        });
    };
    DynaNodeMasterService.prototype.addWorker = function (worker) {
        this._workersArray.push(worker);
        this._workersDic[worker.dynaNodeAddress] = worker;
        if (console_INVESTIGATE2665)
            console.warn('INVESTIGATE2665 - 90006 Add worker', worker.dynaNodeAddress);
    };
    DynaNodeMasterService.prototype.removeWorker = function (workerDynaNodeAddress) {
        this._workersArray = this._workersArray.filter(function (sw) { return sw.dynaNodeAddress !== workerDynaNodeAddress; });
        delete this._workersDic[workerDynaNodeAddress];
    };
    Object.defineProperty(DynaNodeMasterService.prototype, "_traceData", {
        get: function () {
            return { service: this.friendlyName };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynaNodeMasterService.prototype, "_debug_service", {
        get: function () {
            return this._service;
        },
        enumerable: true,
        configurable: true
    });
    return DynaNodeMasterService;
}());
exports.DynaNodeMasterService = DynaNodeMasterService;
var _debug_guid_number = 0;
process._debug_guid = function () { return "DG__" + _debug_guid_number++; };
//# sourceMappingURL=DynaNodeMasterService.js.map